export default __webpack_public_path__ + "static/media/voiceCall.e8323f95.svg";